/* eslint-disable no-case-declarations */
import {
  DELETE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
  GET_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
  POST_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS,
  UPDATE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS
} from '../types/temporaryLivingTypes';

const handleTemporaryLivingReducer = (draft, action) => {
  if (!draft.authorizationDetails[draft.currentAuthId]) draft.authorizationDetails[draft.currentAuthId] = {};
  if (draft.currentAuthId && !draft.authorizationDetails[draft.currentAuthId].authTemporaryLiving)
    draft.authorizationDetails[draft.currentAuthId].authTemporaryLiving = [];

  switch (action.type) {
    case UPDATE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS:
    case POST_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS:
    case GET_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS:
    case DELETE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS:
      draft.authorizationDetails[draft.currentAuthId].authTemporaryLiving = action.response;
      break;
      
    default:
      break;
  }
  return draft;
};

export default handleTemporaryLivingReducer;
